// Óleos novos (Etapa 2) da aba "Protocolos de Óleos Essenciais".
// Texto transcrito do arquivo protocolos_oleos_completo.md, sem reescrita.
// De Air-X até Lime, na ordem do arquivo.

import type { FichaSituacoes } from './fichasSituacoes'

const INTERNO_AGUA =
  'pingue 1 gota em uma colher e tome com água. Se preferir, use uma cápsula vegetal.'

export interface OleoNovo {
  id: string
  // Nome em português (sem repetir quando igual ao inglês)
  portugues: string
  // Nome em inglês
  ingles: string
}

export const CATALOGO_NOVOS: OleoNovo[] = [
  { id: 'novo-airx', portugues: 'Air-X', ingles: 'Air-X' },
  { id: 'novo-basil', portugues: 'Manjericão', ingles: 'Basil' },
  { id: 'novo-blackpepper', portugues: 'Pimenta-Preta', ingles: 'Black Pepper' },
  { id: 'novo-cardamom', portugues: 'Cardamomo', ingles: 'Cardamom' },
  { id: 'novo-citronella', portugues: 'Citronela', ingles: 'Citronella' },
  { id: 'novo-citrusbloom', portugues: 'Citrus Bloom', ingles: 'Citrus Bloom' },
  { id: 'novo-cypress', portugues: 'Cipreste', ingles: 'Cypress' },
  { id: 'novo-marjoram', portugues: 'Manjerona', ingles: 'Marjoram' },
  { id: 'novo-myrrh', portugues: 'Mirra', ingles: 'Myrrh' },
  { id: 'novo-niaouli', portugues: 'Niaouli', ingles: 'Niaouli' },
  { id: 'novo-petitgrain', portugues: 'Laranja Amarga', ingles: 'Petitgrain' },
  { id: 'novo-romanchamomile', portugues: 'Camomila-Romana', ingles: 'Roman Chamomile' },
  { id: 'novo-sandalohavaiano', portugues: 'Sândalo Havaiano', ingles: 'Sândalo Havaiano' },
  { id: 'novo-siberianfir', portugues: 'Pinheiro-Siberiano', ingles: 'Siberian Fir' },
  { id: 'novo-ylangylang', portugues: 'Ylang Ylang', ingles: 'Ylang Ylang' },
  { id: 'novo-align', portugues: 'Align', ingles: 'Align' },
  { id: 'novo-anchor', portugues: 'Anchor', ingles: 'Anchor' },
  { id: 'novo-arise', portugues: 'Arise', ingles: 'Arise' },
  { id: 'novo-arborvitae', portugues: 'Arborvitae', ingles: 'Arborvitae' },
  { id: 'novo-blackspruce', portugues: 'Black Spruce', ingles: 'Black Spruce' },
  { id: 'novo-bluetansy', portugues: 'Blue Tansy', ingles: 'Blue Tansy' },
  { id: 'novo-cheer', portugues: 'Cheer', ingles: 'Cheer' },
  { id: 'novo-cilantro', portugues: 'Coentro', ingles: 'Cilantro' },
  { id: 'novo-cinnamonbark', portugues: 'Canela', ingles: 'Cinnamon Bark' },
  { id: 'novo-console', portugues: 'Console', ingles: 'Console' },
  { id: 'novo-fennel', portugues: 'Erva-doce', ingles: 'Fennel' },
  { id: 'novo-forgive', portugues: 'Forgive', ingles: 'Forgive' },
  { id: 'novo-greenmandarin', portugues: 'Tangerina Verde', ingles: 'Green Mandarin' },
  { id: 'novo-guaiacwood', portugues: 'Palo Santo', ingles: 'Guaiacwood' },
  { id: 'novo-helichrysum', portugues: 'Helicriso', ingles: 'Helichrysum' },
  { id: 'novo-holidayjoy', portugues: 'Holiday Joy', ingles: 'Holiday Joy' },
  { id: 'novo-holidaypeace', portugues: 'Holiday Peace', ingles: 'Holiday Peace' },
  { id: 'novo-hope', portugues: 'Hope', ingles: 'Hope' },
  { id: 'novo-lemongrass', portugues: 'Capim-limão', ingles: 'Lemongrass' },
  { id: 'novo-madagascarvanilla', portugues: 'Madagascar Vanilla', ingles: 'Madagascar Vanilla' },
  { id: 'novo-midnightforest', portugues: 'Midnight Forest', ingles: 'Midnight Forest' },
  { id: 'novo-palmarosa', portugues: 'Palmarosa', ingles: 'Palmarosa' },
  { id: 'novo-passion', portugues: 'Passion', ingles: 'Passion' },
  { id: 'novo-pasttense', portugues: 'Past Tense', ingles: 'Past Tense' },
  { id: 'novo-pinkpepper', portugues: 'Pimenta Rosa', ingles: 'Pink Pepper' },
  { id: 'novo-purify', portugues: 'Purify', ingles: 'Purify' },
  { id: 'novo-redmandarin', portugues: 'Tangerina Vermelha', ingles: 'Red Mandarin' },
  { id: 'novo-rosemary', portugues: 'Alecrim', ingles: 'Rosemary' },
  { id: 'novo-terrashield', portugues: 'Terrashield', ingles: 'Terrashield' },
  { id: 'novo-whisper', portugues: 'Mix de Perfume Feminino', ingles: 'Whisper' },
  { id: 'novo-citrusbliss', portugues: 'Citrus Bliss', ingles: 'Citrus Bliss' },
  { id: 'novo-clove', portugues: 'Cravo', ingles: 'Clove' },
  { id: 'novo-coriander', portugues: 'Coentro-semente', ingles: 'Coriander' },
  { id: 'novo-douglasfir', portugues: 'Douglas Fir', ingles: 'Douglas Fir' },
  { id: 'novo-ervabaleeira', portugues: 'Erva Baleeira', ingles: 'Erva Baleeira' },
  { id: 'novo-hdclear', portugues: 'HD Clear', ingles: 'HD Clear' },
  { id: 'novo-jasmine', portugues: 'Jasmim', ingles: 'Jasmine Touch' },
  { id: 'novo-juniperberry', portugues: 'Zimbro', ingles: 'Juniper Berry' },
  { id: 'novo-lemoneucalyptus', portugues: 'Eucalipto-Limão', ingles: 'Lemon Eucalyptus' },
  { id: 'novo-lime', portugues: 'Lima', ingles: 'Lime' },
  { id: 'novo-motivate', portugues: 'Motivate', ingles: 'Motivate' },
]

const D10 = '1 gota + 10 de óleo de coco fracionado'
const D20 = '1 gota + 20 de óleo de coco fracionado'

export const FICHAS_NOVAS: Record<string, FichaSituacoes> = {
  'novo-airx': {
    diluicao: D10,
    situacoes: [
      { situacao: 'Sono revigorante', topico: 'sola dos pés antes de dormir.' },
      { situacao: 'Calmante e energizante', topico: 'peito.' },
      { situacao: 'Massagem relaxante', topico: 'massagem.' },
    ],
  },

  'novo-basil': {
    diluicao: D10,
    situacoes: [
      {
        situacao: 'Fadiga mental e foco',
        aromatico: 'nas mãos em concha ou difusor.',
        topico: 'testa.',
      },
      { situacao: 'Cansaço', topico: 'sob o nariz, sola dos pés, nuca e testa.' },
      { situacao: 'Náusea e cólicas', interno: INTERNO_AGUA, topico: 'abdômen.' },
    ],
  },

  'novo-blackpepper': {
    diluicao: D10,
    situacoes: [
      {
        situacao: 'Ansiedade',
        aromatico: 'nas mãos em concha ou difusor.',
        topico: 'sob o nariz ou sola dos pés.',
      },
      { situacao: 'Resfriado e calafrios', interno: INTERNO_AGUA, topico: 'sola dos pés ou coluna.' },
      { situacao: 'Vias aéreas', aromatico: 'difusor.', topico: 'peito.' },
      { situacao: 'Digestão e gases', interno: INTERNO_AGUA, topico: 'abdômen.' },
      { situacao: 'Circulação fraca, extremidades frias', topico: 'com compressa quente.' },
    ],
  },

  'novo-cardamom': {
    diluicao: D10,
    situacoes: [
      { situacao: 'Fadiga mental e confusão', topico: 'sob o nariz e nuca.' },
      { situacao: 'Congestão', aromatico: 'difusor.', topico: 'peito e ponte do nariz.' },
      { situacao: 'Dor de estômago e constipação', topico: 'abdômen.' },
      { situacao: 'Emocional (do egocêntrico ao caridoso)', aromatico: 'nas mãos em concha.' },
    ],
  },

  'novo-citronella': {
    diluicao: D10,
    situacoes: [
      {
        situacao: 'Emocional (de lesão para precaução)',
        aromatico: 'nas mãos em concha ou difusor.',
      },
      {
        situacao: 'Inflamação digestiva',
        topico: 'sola dos pés, parte superior do abdômen e fígado.',
      },
    ],
  },

  'novo-citrusbloom': {
    diluicao: D10,
    situacoes: [
      {
        situacao: 'Ansiedade e tristeza',
        aromatico: 'difusor ou 1 gota na palma das mãos.',
        topico: 'pulsos.',
      },
      {
        situacao: 'Sono, desânimo, tensão e estresse',
        aromatico: 'difusor ou 1 gota na palma das mãos.',
      },
      {
        situacao: 'Feminilidade',
        aromatico: 'difusor.',
        topico: '3 dedos abaixo do umbigo, massageando.',
      },
    ],
  },

  'novo-cypress': {
    diluicao: D10,
    situacoes: [
      { situacao: 'Pernas inquietas e circulação', topico: '' },
      { situacao: 'Retenção de líquidos', topico: '' },
      { situacao: 'Celulite', topico: 'com eucalipto, compressa quente.' },
    ],
  },

  'novo-marjoram': {
    diluicao: D10,
    situacoes: [
      { situacao: 'Cãibras e entorses', topico: '' },
      { situacao: 'Tendinite e artrite', topico: '' },
      { situacao: 'Enxaquecas', topico: 'nuca, linha do cabelo, têmporas.' },
      { situacao: 'Cólica', topico: 'abdômen e parte inferior das costas.' },
    ],
  },

  'novo-myrrh': {
    diluicao: D10,
    situacoes: [
      { situacao: 'Meditação', aromatico: 'difusor.' },
      { situacao: 'Tristeza e ansiedade', aromatico: 'difusor.', topico: 'pontos reflexos.' },
      { situacao: 'Congestão', aromatico: 'difusor.', topico: 'peito.' },
      { situacao: 'Cólicas', topico: 'abdômen.' },
      { situacao: 'Pele seca e linhas finas', topico: '' },
      { situacao: 'Gengiva', nota: 'aplicar diretamente.' },
    ],
  },

  'novo-niaouli': {
    diluicao: D10,
    situacoes: [
      { situacao: 'Foco', aromatico: '' },
      { situacao: 'Respiratório', aromatico: 'vapor ou difusor.', topico: 'peito e costas.' },
      { situacao: 'Imunidade', aromatico: '', topico: 'sola dos pés e coluna.' },
      { situacao: 'Acne', topico: '' },
      { situacao: 'Dor de ouvido', topico: 'ao redor.' },
    ],
  },

  'novo-petitgrain': {
    diluicao: '1 gota + 10 de óleo de coco fracionado',
    situacoes: [
      {
        situacao: 'Pensamento ansioso e raiva repentina',
        aromatico: 'nas mãos em concha ou difusor.',
        topico: 'nuca, pulsos e área do estômago.',
      },
      {
        situacao: 'Nervos e insônia',
        aromatico: 'difusor antes de dormir.',
        topico: 'nuca, pulsos e área do estômago.',
      },
      {
        situacao: 'Equilíbrio emocional',
        aromatico: 'inale 1 gota nas mãos em concha ou no difusor.',
      },
      { situacao: 'Cãibras', topico: '' },
    ],
    atencao: 'não aplicar na pele antes de exposição ao sol (causa manchas).',
  },

  'novo-romanchamomile': {
    diluicao: D10,
    situacoes: [
      { situacao: 'Estresse', aromatico: '', topico: 'nuca.' },
      { situacao: 'Insônia', aromatico: '', topico: 'nuca.' },
      { situacao: 'Raiva e agitação', aromatico: '', topico: 'sob o nariz ou nuca.' },
      { situacao: 'TPM e cãibras', topico: 'abdômen.' },
      { situacao: 'Pele', topico: '' },
    ],
  },

  'novo-sandalohavaiano': {
    diluicao: D10,
    situacoes: [
      { situacao: 'Calmante', aromatico: '', topico: 'sob o nariz.' },
      { situacao: 'Cicatrizes e manchas', topico: '' },
      { situacao: 'Pele e couro cabeludo secos', topico: 'ou no xampu.' },
      { situacao: 'Cãibras', topico: '' },
    ],
  },

  'novo-siberianfir': {
    diluicao: D10,
    situacoes: [
      { situacao: 'Músculos doloridos', topico: '' },
      { situacao: 'Congestão', aromatico: '', topico: 'peito, sola dos pés, coluna.' },
      { situacao: 'Digestão lenta', topico: 'abdômen.' },
      { situacao: 'Circulação', topico: '' },
    ],
  },

  'novo-ylangylang': {
    diluicao: D10,
    situacoes: [
      { situacao: 'Ansiedade, frustração, medo', aromatico: '', topico: 'sob o nariz ou sola dos pés.' },
      { situacao: 'Equilíbrio', aromatico: '', topico: 'nuca, testa, atrás das orelhas.' },
    ],
  },

  'novo-align': {
    diluicao: D10,
    situacoes: [
      {
        situacao: 'Disperso e sobrecarregado',
        aromatico: 'nas mãos em concha.',
        topico: 'sob o nariz e testa.',
      },
      {
        situacao: 'Foco e tranquilidade',
        aromatico: 'difusor.',
        topico: 'topo da cabeça, pescoço e testa.',
      },
      { situacao: 'Meditação e oração', aromatico: 'difusor.', topico: 'coração e testa.' },
      {
        situacao: 'Apatia e baixa energia',
        aromatico: 'difusor.',
        topico: 'pulsos, coração, sola dos pés.',
      },
      {
        situacao: 'Raiva e humor desequilibrado',
        aromatico: 'difusor; ou 1 a 2 gotas na palma das mãos, esfregue e respire fundo.',
      },
    ],
  },

  'novo-anchor': {
    diluicao: D10,
    situacoes: [
      {
        situacao: 'Meditação, oração e foco',
        aromatico: 'difusor.',
        topico: 'testa, atrás das orelhas, coluna, sola dos pés.',
      },
      {
        situacao: 'Ancorado, corajoso e autêntico',
        aromatico: 'difusor.',
        topico: 'tornozelos, coluna, sola dos pés.',
      },
      {
        situacao: 'Calmo e descansado',
        aromatico: 'difusor.',
        topico: 'nuca, coluna, sola dos pés.',
      },
      {
        situacao: 'Falar a verdade',
        aromatico: 'difusor.',
        topico: 'garganta, coluna, sola dos pés.',
      },
      {
        situacao: 'Temeroso e desconectado',
        aromatico: 'difusor.',
        topico: 'pulsos, coração, sola dos pés.',
      },
    ],
  },

  'novo-arise': {
    diluicao: D10,
    situacoes: [
      {
        situacao: 'Conexão com o eu e o poder superior',
        aromatico: 'difusor.',
        topico: 'coroa, coração, coluna.',
      },
      {
        situacao: 'Intencional e orientado à ação',
        aromatico: 'difusor.',
        topico: 'tornozelos, coluna, sola dos pés.',
      },
      {
        situacao: 'Empoderado e corajoso',
        aromatico: 'difusor.',
        topico: 'testa, coração, sola dos pés.',
      },
      {
        situacao: 'Sobrecarregado, tagarelice mental',
        aromatico: 'difusor.',
        topico: 'testa, calcanhares, atrás das orelhas.',
      },
      {
        situacao: 'Alterações de humor',
        aromatico: 'difusor.',
        topico: 'topo da cabeça, coração, atrás das orelhas, sola dos pés, pulsos.',
      },
    ],
  },

  'novo-arborvitae': {
    diluicao: D10,
    situacoes: [
      { situacao: 'Estimulante', topico: 'sob o nariz e nuca.' },
      { situacao: 'Respiratório', topico: 'peito.' },
      { situacao: 'Pele', topico: 'com lavanda.' },
    ],
  },

  'novo-blackspruce': {
    diluicao: D10,
    situacoes: [
      {
        situacao: 'Fadiga e melancolia',
        topico: 'testa, rins e/ou coração, repetindo conforme necessário.',
      },
      { situacao: 'Alta performance e desconexão', topico: 'pulsos e coração.' },
      {
        situacao: 'Respiratório',
        aromatico: '2 a 3 gotas em água quente, cubra a cabeça com toalha e inale.',
      },
      {
        situacao: 'Circulação e estresse',
        topico: 'parte superior da coluna, costas, pés, 2 a 4 vezes ao dia.',
      },
    ],
  },

  'novo-bluetansy': {
    diluicao: D10,
    situacoes: [
      { situacao: 'Tensão e enxaqueca', topico: 'têmporas e lados do nariz.' },
      {
        situacao: 'Respiratório',
        topico: 'peito e/ou sob o nariz, com eucalipto ou hortelã-pimenta.',
      },
      { situacao: 'Digestão', topico: 'abdômen.' },
      { situacao: 'Dores musculares', topico: 'na área.' },
      { situacao: 'Alergias', topico: 'sola dos pés.' },
      { situacao: 'Pele', topico: 'com Salubelle.' },
    ],
  },

  'novo-cheer': {
    diluicao: D10,
    situacoes: [
      {
        situacao: 'Depressão e desânimo',
        aromatico: 'difusor ou nas mãos em concha.',
        topico: 'pulsos, sob o nariz e testa.',
      },
      {
        situacao: 'Ansiedade e desconexão',
        aromatico: 'difusor ou nas mãos em concha.',
        topico: 'sob o nariz e testa.',
      },
      { situacao: 'TPM', nota: 'mesmo uso.' },
      { situacao: 'Inflamação e rigidez', topico: '' },
      { situacao: 'Digestão', topico: 'abdômen e sola dos pés.' },
    ],
  },

  'novo-cilantro': {
    diluicao: D10,
    situacoes: [
      { situacao: 'Ansiedade', aromatico: 'inale ou difusor.' },
      { situacao: 'Gases, inchaço e constipação', topico: 'abdômen.' },
      {
        situacao: 'Suporte do fígado e dos rins',
        interno: INTERNO_AGUA,
        topico: 'sobre fígado e rins.',
      },
    ],
  },

  'novo-cinnamonbark': {
    diluicao: D20,
    situacoes: [
      {
        situacao: 'Resfriado e gripe',
        interno: 'SOMENTE em cápsula.',
        topico: 'sola dos pés.',
        aromatico: 'apenas no difusor.',
      },
      { situacao: 'Circulação', topico: 'sola dos pés.' },
      { situacao: 'Tensão muscular e dor', topico: '' },
    ],
    atencao:
      'Recomenda-se INGERIR EM CÁPSULA, pois pode causar irritação e ardência ao ingerir puro com água. Diluir sempre 1 gota para 20 de óleo de coco fracionado no uso tópico. A pele pode ficar temporariamente aquecida e vermelha. Tenha cautela no uso e siga as orientações.',
  },

  'novo-console': {
    diluicao: D10,
    situacoes: [
      { situacao: 'Luto e tristeza', aromatico: 'difusor.', topico: 'nariz e peito.' },
      { situacao: 'Liberação emocional', aromatico: 'difusor.', topico: 'nariz e coração.' },
      { situacao: 'Medo e dor emocional', aromatico: 'difusor.', topico: 'nariz e peito.' },
      { situacao: 'Pele', topico: 'com óleo transportador.' },
    ],
  },

  'novo-fennel': {
    diluicao: D10,
    situacoes: [
      { situacao: 'TPM e menopausa', topico: 'abdômen.' },
      { situacao: 'Cólicas e espasmos', topico: 'músculos.' },
      { situacao: 'Edema', topico: 'com toranja.' },
      { situacao: 'Tosse', topico: 'peito e garganta.' },
    ],
  },

  'novo-forgive': {
    diluicao: D10,
    situacoes: [
      { situacao: 'Perdão e apego', aromatico: 'difusor.', topico: 'têmporas e nuca.' },
      { situacao: 'Ansiedade', topico: 'sob o nariz, testa e/ou nuca.' },
      { situacao: 'Toxicidade emocional', aromatico: 'difusor.', topico: 'sob o nariz e/ou peito.' },
      { situacao: 'Irritabilidade', aromatico: 'difusor.', topico: 'pulsos.' },
    ],
  },

  'novo-greenmandarin': {
    diluicao: D10,
    situacoes: [
      {
        situacao: 'Deprimido, agitado, nervoso',
        aromatico: 'difusor.',
        interno: INTERNO_AGUA,
        topico: 'pulsos.',
      },
      {
        situacao: 'Ansiedade situacional',
        aromatico: 'nas mãos em concha ou difusor.',
        topico: '1 a 2 gotas sob o nariz.',
      },
      { situacao: 'Digestão', topico: 'abdômen.' },
      { situacao: 'Emocional (do angustiado ao despreocupado)', nota: 'Aromático ou tópico.' },
    ],
  },

  'novo-guaiacwood': {
    diluicao: D10,
    situacoes: [
      { situacao: 'Estresse e relaxamento', aromatico: 'difusor ou banho quente.' },
      { situacao: 'Cãibras', topico: 'movimentos circulares.' },
      { situacao: 'Dores musculares', topico: '' },
      { situacao: 'Foco e sono', aromatico: 'difusor.' },
    ],
  },

  'novo-helichrysum': {
    diluicao: D10,
    situacoes: [
      { situacao: 'Rugas e estrias', topico: 'com mirra.' },
      { situacao: 'Cicatrizes e feridas', topico: '' },
      { situacao: 'Choque e dor', topico: 'nuca ou área.' },
    ],
  },

  'novo-holidayjoy': {
    diluicao: D10,
    situacoes: [
      {
        situacao: 'Ambiente festivo, sobrecarga emocional e estresse',
        aromatico: 'difusor ou nas mãos em concha.',
      },
      { situacao: 'Dor de cabeça', topico: 'têmporas e nuca.' },
      { situacao: 'Dores musculares', topico: '' },
    ],
    atencao: 'nunca ingerir.',
  },

  'novo-holidaypeace': {
    diluicao: D10,
    situacoes: [
      {
        situacao: 'Ambiente festivo, calmante, ansiedade',
        aromatico: 'difusor ou nas mãos em concha.',
        topico: 'pulsos, nuca, coluna, sola dos pés.',
      },
      { situacao: 'Foco', aromatico: '', topico: 'sob o nariz e nuca.' },
    ],
    atencao: 'nunca ingerir.',
  },

  'novo-hope': {
    comoAplicar: 'Roll-on, já diluído: não precisa de proporção.',
    situacoes: [
      { situacao: 'Autoestima, tristeza e solidão', topico: 'coração, nuca, sola dos pés.' },
      {
        situacao: 'Falta de esperança',
        aromatico: 'difusor.',
        topico: 'sob o nariz, nuca, sola dos pés.',
      },
    ],
  },

  'novo-lemongrass': {
    diluicao: D20,
    situacoes: [
      { situacao: 'Constipação e retenção', topico: 'abdômen ou sola dos pés.', interno: INTERNO_AGUA },
      { situacao: 'Dores articulares', topico: '' },
      { situacao: 'Congestão linfática', interno: INTERNO_AGUA, topico: 'sola dos pés.' },
    ],
  },

  'novo-madagascarvanilla': {
    diluicao: D10,
    situacoes: [
      {
        situacao: 'Ansiedade e compulsão por doces',
        aromatico: 'nas mãos em concha.',
        topico: 'pulsos e nuca.',
      },
      { situacao: 'TPM e cólicas', aromatico: '', topico: 'ventre.' },
      { situacao: 'Sono', aromatico: '', topico: 'pulsos e sola dos pés.' },
      { situacao: 'Pele', topico: 'no hidratante, no rosto.' },
    ],
  },

  'novo-midnightforest': {
    diluicao: D10,
    situacoes: [
      {
        situacao: 'Ansiedade e esgotamento',
        aromatico: 'difusor.',
        topico: 'sob o nariz, testa, nuca, sola dos pés.',
      },
      {
        situacao: 'Criatividade e concentração',
        aromatico: '',
        topico: 'sob o nariz, nuca, testa.',
      },
      { situacao: 'Dor de cabeça e tensão', topico: 'pulsos, pescoço ou coração.' },
      { situacao: 'Estresse', aromatico: '' },
    ],
  },

  'novo-palmarosa': {
    diluicao: D10,
    situacoes: [
      { situacao: 'Rugas, manchas, cicatrizes', nota: '1 a 2 gotas no hidratante ou óleo vegetal.' },
      { situacao: 'Acne', topico: '' },
      { situacao: 'Amor incondicional', aromatico: 'nas mãos em concha.' },
    ],
  },

  'novo-passion': {
    diluicao: D10,
    situacoes: [
      {
        situacao: 'Apatia e baixa energia',
        aromatico: 'difusor ou nas mãos em concha.',
      },
      { situacao: 'Névoa mental', aromatico: 'difusor.', topico: 'dedos.' },
      { situacao: 'Digestão lenta e menstruação', topico: 'abdômen inferior.' },
    ],
  },

  'novo-pasttense': {
    comoAplicar: 'Roll-on, já diluído: não precisa de proporção.',
    situacoes: [
      { situacao: 'Dor de cabeça', nota: 'têmporas, testa e nuca.' },
      { situacao: 'Tensão e estresse', nota: 'pulsos; Aromático: nas mãos em concha.' },
      { situacao: 'Sono reparador', nota: 'nuca.' },
      { situacao: 'Ondas de calor', nota: 'abdômen e nuca.' },
      { situacao: 'Dores no pescoço e ombro', nota: 'na área.' },
    ],
  },

  'novo-pinkpepper': {
    diluicao: D10,
    situacoes: [
      {
        situacao: 'Náusea, gases, inchaço',
        topico: 'com cardamomo, no abdômen.',
        interno: INTERNO_AGUA,
      },
      { situacao: 'TPM e cólicas', topico: 'abdômen, com manjerona e gerânio.' },
      { situacao: 'Respiratório', topico: 'peito e costas.' },
    ],
  },

  'novo-purify': {
    diluicao: D10,
    situacoes: [
      { situacao: 'Desencorajamento', aromatico: 'difusor.' },
      { situacao: 'Acne', topico: '' },
      { situacao: 'Desodorante', topico: 'diluído sob os braços.' },
    ],
  },

  'novo-redmandarin': {
    diluicao: D10,
    situacoes: [
      { situacao: 'Acne e pele oleosa', topico: 'nas regiões afetadas.' },
      {
        situacao: 'Congestão e tosse',
        aromatico: 'inale das mãos em concha.',
        topico: 'peito, costas ou testa.',
      },
      { situacao: 'Digestão (inchaço e gases)', topico: 'abdômen.' },
      {
        situacao: 'Pele (rugas, estrias, cicatrizes, manchas)',
        topico: 'na rotina de cuidados e nas regiões afetadas.',
      },
    ],
    atencao: 'não expor ao sol após uso tópico.',
  },

  'novo-rosemary': {
    diluicao: D10,
    situacoes: [
      {
        situacao: 'Memória e foco',
        aromatico: 'inale 1 gota nas mãos ou utilize no difusor.',
      },
      {
        situacao: 'Fadiga mental',
        aromatico: 'difusor.',
        topico: 'na área do estômago e nuca.',
      },
      { situacao: 'Dores musculares', topico: 'na área afetada.' },
    ],
    atencao: 'Nunca usar em hipertensos e epiléticos.',
  },

  'novo-terrashield': {
    diluicao: D10,
    situacoes: [
      { situacao: 'Limites saudáveis', aromatico: 'difusor.', topico: 'na pele.' },
      { situacao: 'Pele', topico: 'com lavanda.' },
    ],
  },

  'novo-whisper': {
    diluicao: D10,
    situacoes: [
      { situacao: 'Raiva', aromatico: 'difusor.', topico: 'pulsos.' },
      { situacao: 'Autoexpressão', aromatico: '', topico: 'sob o nariz.' },
      { situacao: 'Autoconfiança e criatividade', aromatico: '', topico: 'pulsos.' },
      { situacao: 'Equilíbrio hormonal e ondas de calor', topico: 'pulsos e nuca.' },
    ],
  },

  'novo-citrusbliss': {
    diluicao: D10,
    situacoes: [
      {
        situacao: 'Baixa energia, estresse, ansiedade, tristeza',
        aromatico: 'difusor.',
        topico: 'sob o nariz e nuca.',
      },
    ],
  },

  'novo-clove': {
    diluicao: D20,
    situacoes: [
      { situacao: 'Imunidade', interno: INTERNO_AGUA, topico: 'sola dos pés.' },
      { situacao: 'Circulação', topico: 'coluna e sola dos pés.' },
      { situacao: 'Dor de dente', topico: 'diluído na área.' },
    ],
    atencao:
      'O cravo pode causar irritação se aplicado puro. A recomendação é diluir o óleo essencial em um óleo de coco fracionado (ou outro óleo carreador) antes do uso tópico.',
  },

  'novo-coriander': {
    diluicao: D10,
    situacoes: [
      {
        situacao: 'Baixa energia e exaustão',
        aromatico: 'nas mãos em concha.',
        topico: 'sola dos pés.',
      },
      { situacao: 'Gases e náusea', topico: 'abdômen.' },
      { situacao: 'Dor articular', topico: '' },
    ],
  },

  'novo-douglasfir': {
    diluicao: D10,
    situacoes: [
      {
        situacao: 'Névoa mental e baixa energia',
        aromatico: 'difusor.',
        topico: 'têmporas e testa.',
      },
      { situacao: 'Congestão', topico: 'peito e ponte do nariz.' },
      { situacao: 'Dor muscular', topico: 'com wintergreen.' },
    ],
  },

  'novo-ervabaleeira': {
    diluicao: D10,
    situacoes: [
      { situacao: 'Foco e clareza mental', aromatico: 'nas mãos ou difusor.' },
      { situacao: 'Raiva, irritação e estresse', aromatico: '' },
      { situacao: 'Dores musculares', nota: '1 gota no creme corporal.' },
      { situacao: 'Cicatrização', topico: '' },
    ],
  },

  'novo-hdclear': {
    diluicao: D20,
    situacoes: [
      {
        situacao: 'Acne, pele oleosa, manchas, dermatite',
        topico:
          'no rosto ou na área de interesse. Misture 1 gota com 20 de óleo de coco fracionado, ou aplique o óleo no local e passe o óleo de coco fracionado por cima.',
      },
    ],
    atencao: 'não vem diluído. Evitar a área dos olhos.',
  },

  'novo-jasmine': {
    comoAplicar: 'Roll-on, já diluído: não precisa de proporção.',
    situacoes: [
      { situacao: 'Depressão e ansiedade', aromatico: '', topico: 'sob o nariz e nuca.' },
      { situacao: 'Exaustão', nota: 'nuca e sola dos pés.' },
      { situacao: 'Pele', nota: '2 gotas no hidratante.' },
      { situacao: 'TPM', nota: 'nuca e abdômen.' },
    ],
  },

  'novo-juniperberry': {
    diluicao: D10,
    situacoes: [
      { situacao: 'Retenção de líquidos', interno: INTERNO_AGUA, topico: 'abdômen, com limão.' },
      { situacao: 'Detox', interno: INTERNO_AGUA },
      { situacao: 'Dores articulares e acne', topico: '' },
      { situacao: 'Tensão e estresse', aromatico: 'nas mãos em concha.' },
    ],
  },

  'novo-lemoneucalyptus': {
    diluicao: D10,
    situacoes: [
      { situacao: 'Vias aéreas (tosse, congestão)', topico: 'peito e costas, 2 a 4 vezes ao dia.' },
      {
        situacao: 'Dor de cabeça e dores articulares',
        topico: 'sola dos pés e áreas de interesse, 2 a 4 vezes ao dia.',
      },
      {
        situacao: 'Febre, calor e esgotamento',
        topico: 'áreas de interesse, parte superior da coluna, testa e planta dos pés, conforme necessário.',
      },
      { situacao: 'Circulação', topico: 'planta dos pés e sobre o fígado, 2 a 4 vezes ao dia.' },
    ],
    atencao: 'pele sensível, sempre diluir.',
  },

  'novo-motivate': {
    diluicao: D10,
    situacoes: [
      {
        situacao: 'Confiança, coragem, motivação',
        aromatico: 'difusor.',
        topico: 'nariz, testa, nuca, peito.',
      },
      {
        situacao: 'Fadiga mental',
        nota: 'Aromático.',
        topico: 'têmporas e nuca.',
      },
      {
        situacao: 'Esgotamento',
        aromatico: 'nas mãos em concha.',
        topico: 'sob o nariz, suprarrenais, sola dos pés.',
      },
      {
        situacao: 'Confusão',
        aromatico: 'nas mãos em concha.',
      },
      {
        situacao: 'Tristeza',
        aromatico: 'difusor.',
        topico: 'peito, testa, nuca.',
      },
      {
        situacao: 'Digestão',
        topico: 'abdômen.',
      },
    ],
  },

  'novo-lime': {
    diluicao: D10,
    situacoes: [
      { situacao: 'Memória e clareza', aromatico: '' },
      { situacao: 'Exaustão e tristeza', aromatico: 'difusor.', topico: 'orelhas ou nuca.' },
      { situacao: 'Digestivo e urinário', interno: 'algumas gotas em água.' },
    ],
    atencao: 'não expor ao sol após uso tópico.',
  },
}
